import component from "./LotStick";

export default component;
